import { AppRoutes } from 'routes';
import { Product } from '@inter-ikea-storageone/range';

export const getArticlesWithQuantity = (products: Product[]) => {
  return products.reduce((acc, curr) => {
    const articleNumber = curr.globalItemNo ?? '';
    const existing = acc.find(({ articleNumber: other }) => other && articleNumber === other);

    if (existing) {
      existing.quantity += 1;
      return acc;
    }

    return [...acc, { articleNumber, quantity: 1 }];
  }, [] as { articleNumber: string; quantity: number }[]);
};

export const calculateLatency = (startTime: Date, endTime: Date) => {
  return Math.abs(startTime.getTime() - endTime.getTime());
};

export const translateNavigationPathToAnalytics = (path: string): string | null => {
  if (path.length === 0) return null;
  path = path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;

  if (path === AppRoutes.HOME || path === AppRoutes.LANDING_PAGE) {
    return 'landing_page';
  }
  if (path === AppRoutes.SUMMARY) {
    return 'summary_page';
  }
  if (path === AppRoutes.GUIDE) {
    return 'guide_page';
  }

  return 'planner_page';
};
